import styled from "styled-components";
const MainDiv = styled<any>("div")`
  display: flex;
  gap: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "8px" : "16px"};
  padding-bottom: 12px;
  ::-webkit-scrollbar {
    height: 0px !important;
  }
`;
const ListingFilterDiv = styled<any>("div")`
  width: fit-content;
  display: flex;
  gap: 2px;
  flex-direction: row;
  border-radius: 4px;
  align-items: center;
  padding: 4px;
  cursor: pointer;
  color: ${({ isSelected, unselectedTextColor, unselectedColor }: any) =>
    isSelected ? unselectedColor : unselectedTextColor};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  border: ${({ isSelected, unselectedColor }: any) =>
    !isSelected ? "1px solid #AFAFAF" : unselectedColor};
  background: ${({ isSelected, selectColor, unselectedColor }: any) =>
    isSelected ? selectColor : unselectedColor};
`;
const NameSpan = styled<any>("span")`
  white-space: nowwrap;
`;
interface SearchFilterListingIC {
  selectedItem: any;
  onSelectHandler: any;
  selectColor: string;
  unselectedColor: string;
  unselectedTextColor: string;
  data: any[];
}
const SearchFilterListing = ({
  selectedItem,
  onSelectHandler,
  selectColor,
  unselectedColor,
  unselectedTextColor,
  data,
}: SearchFilterListingIC) => {
  return (
    <MainDiv>
      {data.map((ele: any, index: number) => {
        return (
          <ListingFilterDiv
            key={ele.value + index}
            isSelected={ele.label === selectedItem.label}
            selectColor={selectColor}
            unselectedColor={unselectedColor}
            unselectedTextColor={unselectedTextColor}
            onClick={() => {
              onSelectHandler(ele);
            }}
          >
            <NameSpan>{ele.label} </NameSpan>
          </ListingFilterDiv>
        );
      })}
    </MainDiv>
  );
};
export default SearchFilterListing;
